import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import ReactEcharts from 'echarts-for-react'
import Sticky from 'react-stickynode'
import { loadPairs, loadPerformance, setIndex, setPair, setDate, setPeriod, setCategory, setSort, setUrlDate, setUrlPeriod, setUrlCategory, saveToGA, loadAttributionExcel } from '../../actions'
import { isMobileOnly } from 'react-device-detect'
import i18n from '../../i18n'
import { CopyToClipboard } from 'react-copy-to-clipboard'

import './style.css'

class App extends Component {
  componentWillMount() {
    let { history } = this.props

    this.props.loadPairs().then(() => {
      const hash = history.location.hash.substring(1)
      if (hash !== '') {
        const hash = history.location.hash.substring(1).split('&')
        this.hashActions(hash)
      }
    })

    history.listen(() => {
      const hash = history.location.hash.substring(1).split('&')
      this.hashActions(hash)
    })
  }

  hashActions = hash => {
    if (hash.length > 1 && (hash[0] === 'perfattr' || hash[0] === 'index-attribution')) {
      if (hash[1].includes('index')) {
        const idx = hash[1].split('index=')[1]
        this.props.setIndex(idx)
      }

      if (hash[3] && hash[3].includes('urlDate')) {
        const urlDate = hash[3].split('urlDate=')[1]
        this.props.setUrlDate(urlDate)
      }

      if (hash[4] && hash[4].includes('urlCategory')) {
        const urlCategory = hash[4].split('urlCategory=')[1]
        if (urlCategory.length > 0) {
          this.props.setUrlCategory(decodeURI(urlCategory))
        }
      }

      if (hash[5] && hash[5].includes('urlPeriod')) {
        const urlPeriod = hash[5].split('urlPeriod=')[1]
        if (urlPeriod.length > 0) {
          this.props.setUrlPeriod(urlPeriod)
        }
      }
    }
  }

  setIndex(idx) {
    this.props.setIndex(idx)
  }

  setPair(pair) {
    this.props.setPair(pair)
  }

  setDate(date) {
    this.props.setDate(date)
  }

  setPeriod(period) {
    this.props.setPeriod(period)
  }

  setCategory(cat) {
    this.props.setCategory(cat)
  }

  renderIndexes() {
    if (this.props.pairs) {
      // get unique indexes from the pairs
      let indexes = Array.from(this.props.pairs.reduce((m, t) => m.set(t.index, t), new Map()).values())
      // fill in the category based on cat1 and cat2
      indexes = indexes.map(item => {
        item.category = ''
        if (item.fundCategoryTier1) {
          item.category = item.fundCategoryTier1 + (item.fundCategoryTier2 ? ' - ' + item.fundCategoryTier2 : '')
        } else {
          item.category = 'Other'
        }
        return item
      })
      // get unique categories and sort
      let categories = Array.from(indexes.reduce((m, t) => m.set(t.category, t.category), new Map()).values()).sort()
      // return index selection options grouped by category
      return categories.map(category => (
        <optgroup key={category} label={category}>
          {this.getCategoryOptions(indexes, category)}
        </optgroup>
      ))
    } else {
      return null
    }
  }

  getCategoryOptions(indexes, category) {
    let filtered = indexes.filter(index => index.category === category)
    return filtered.map(item => (
      <option key={item.index} value={item.index}>
        {item.index} - {item.index_name}
      </option>
    ))
  }

  renderPairs() {
    if (this.props.pairs) {
      let index = this.props.index
      let benchmarks = this.props.pairs.filter(function (value) {
        return value.index === index
      })
      return benchmarks.map((item, index) => (
        <option key={item.uu_attribution_id} value={item.uu_attribution_id}>
          {item.benchmark} - {item.benchmark_name}
        </option>
      ))
    } else {
      return null
    }
  }

  reorderCategories(categories) {
    var newCats = []
    if (categories.includes('Sector')) newCats.push('Sector')
    if (categories.includes('Country')) newCats.push('Country')
    if (categories.includes('Region')) newCats.push('Region')
    if (categories.includes('DY')) newCats.push('DY')
    if (categories.includes('EY')) newCats.push('EY')
    if (categories.includes('GeoRev')) newCats.push('GeoRev')
    if (categories.includes('ROE')) newCats.push('ROE')
    if (categories.includes('SY')) newCats.push('SY')
    if (categories.includes('Share Class')) newCats.push('Share Class')
    if (categories.includes('SOE')) newCats.push('SOE')
    if (categories.includes('Size')) newCats.push('Size')
    if (categories.includes('Vol_Qtl')) newCats.push('Vol_Qtl')
    if (categories.includes('BV_Qtl')) newCats.push('BV_Qtl')
    if (categories.includes('Comp. Risk Score')) newCats.push('Comp. Risk Score')
    // if(categories.includes('BB')) newCats.push('BB');
    return newCats
  }

  renderCategories() {
    if (this.props.categories) {
      function attrCatName(value) {
        switch (value) {
          case 'SY':
            return i18n.t('Shareholder Yield Attribution')
          //case 'BB':
          //  return 'Net Buyback Yield Attribution';
          case 'Size':
            return i18n.t('Size Attribution')
          case 'ROE':
            return i18n.t('Return on Equity Attribution')
          case 'EY':
            return i18n.t('Earnings Yield Attribution')
          case 'DY':
            return i18n.t('Dividend Yield Attribution')
          case 'Sector':
            return i18n.t('Sector Attribution')
          case 'Country':
            return i18n.t('Country Attribution')
          case 'Region':
            return i18n.t('Region Attribution')
          case 'Vol_Qtl':
            return i18n.t('Volatility Attribution')
          case 'BV_Qtl':
            return i18n.t('Book Value Attribution')
          case 'SOE':
            return i18n.t('State-Ownership Attribution')
          case 'GeoRev':
            return i18n.t('Geographic Revenue Attribution')
          case 'Share Class':
            return i18n.t('Share Class Attribution')
          case 'Comp. Risk Score':
            return i18n.t('CRS Attribution')
          default:
            return value
        }
      }
      let sortedCats = this.reorderCategories(this.props.categories)
      return sortedCats.map((cat, index) => (
        <option key={cat} value={cat}>
          {attrCatName(cat)}
        </option>
      ))
    } else {
      return null
    }
  }

  renderGlossary() {
    if (this.props.categories) {
      function attrCatGlossary(value) {
        switch (value) {
          case 'SY':
            return i18n.t('SY-gloss')
          case 'BB':
            return i18n.t('BB-gloss')
          case 'ROE':
            return i18n.t('ROE-gloss')
          case 'EY':
            return i18n.t('EY-gloss')
          case 'DY':
            return i18n.t('DY-gloss')
          default:
            return null
        }
      }
      let result = attrCatGlossary(this.props.category)
      return <div className='perffooter'>{result}</div>
    } else {
      return null
    }
  }

  renderPeriods() {
    if (this.props.categoryData.periods) {
      let names = { MTD: 1, QTD: 2, YTD: 3, '1y': 4, '3y': 5, '5y': 6, '10y': 7, SI: 8 }
      function checkForSI(value) {
        switch (value) {
          case 'SI':
            return i18n.t('Since Inception') + '*'
          case '1y':
            return i18n.t('1Y')
          case '3y':
            return i18n.t('3Y')
          case '5y':
            return i18n.t('5Y')
          case '10y':
            return i18n.t('10Y')
          default:
            return i18n.t(value)
        }
      }
      return this.props.categoryData.periods
        .sort((a, b) => names[a.name] - names[b.name])
        .map((period, index) => (
          <button id={'btn' + period.name} key={period.name} className={this.buttonPeriodClass(period.name)} onClick={() => this.setPeriod(period.name)}>
            {checkForSI(period.name)}
          </button>
        ))
    } else {
      return null
    }
  }

  getDateCode(theDate) {
    return new Date(theDate).toISOString().replace('-', '').split('T')[0].replace('-', '')
  }

  renderDates() {
    if (this.props.dates) {
      return this.props.dates.map((date, index) => (
        <option key={index} value={this.getDateCode(date.asOfDate)}>
          {new Date(date.asOfDate).toLocaleDateString().split(',')[0]}
        </option>
      ))
    } else {
      return null
    }
  }

  getSaveToGA = (event, val) => {
    event.preventDefault()
    if (val === 'link') {
      this.props.saveToGA('copy link')
    } else {
      this.props.saveToGA('excel download')
    }
  }

  getExcelDownload = event => {
    event.preventDefault()
    this.props.loadAttributionExcel()
  }

  getAsOfDate() {
    if (this.props.periodData.length > 0) {
      return this.getDateCode(this.props.periodData[0].date)
    } else {
      return ''
    }
  }

  convPerc(value) {
    return Number.parseFloat(value * 100).toFixed(2)
  }

  renderTable() {
    if (this.props.periodData) {
      return this.props.periodData.map((item, index) => (
        <tr key={index} style={{ fontWeight: item.Category === 'Total' ? 'bold' : '500' }}>
          <td rowname='Category'>{item.Category}</td>
          <td rowname='Allocation'>{this.convPerc(item.Allocation)}%</td>
          <td rowname='Stock Selection'>{this.convPerc(item.Selection)}%</td>
          <td rowname='Interaction'>{this.convPerc(item.Interaction)}%</td>
          <td rowname='Total Attribution'>{this.convPerc(item.Total)}%</td>
          <td rowname='Index Weight'>{item.Category !== 'Total' ? this.convPerc(item.IndexWgt) + '%' : '-'}</td>
          <td rowname='Benchmark Weight'>{item.Category !== 'Total' ? this.convPerc(item.BenchmarkWgt) + '%' : '-'}</td>
          <td rowname='+ / - Weight'>{item.Category !== 'Total' ? this.convPerc(item.ActiveWgt) + '%' : '-'}</td>
          <td rowname='WT Index Returns'>{this.convPerc(item.IndexGroupRet)}%</td>
          <td rowname='Benchmark Returns'>{this.convPerc(item.BenchmarkGroupRet)}%</td>
        </tr>
      ))
    } else {
      return null
    }
  }

  buttonPeriodClass(type) {
    return type === this.props.period ? 'button-selected' : ''
  }

  setSortData(column) {
    this.props.setSort(column)
  }

  setTblHeadClass(type) {
    if (type === this.props.sortColumn && this.props.sortDirection === 'DESC') {
      return 'des'
    } else if (type === this.props.sortColumn && this.props.sortDirection === 'ASC') {
      return 'asc'
    } else {
      return ''
    }
  }


  renderGraphs = () => {
    const { forBlog } = this.props
    if (forBlog) {
      return null
    }    
    return(
      <div>
        <div className='row'>
          <div className='perf-details col chart-container'>
            <ReactEcharts option={this.getAttributionOption()} theme='default' style={{ height: 500 }} />
          </div>
        </div>
        <div className='row'>
          <div className='perf-details col-md-6 chart-container' style={{ borderRight: '5px solid white' }}>
            <ReactEcharts option={this.getAverageWeightsOption()} theme='default' style={{ height: 400 }} />
          </div>

          <div className='perf-details col-md-6 chart-container' style={{ borderLeft: '5px solid white' }}>
            <ReactEcharts option={this.getOverUnderOption()} theme='default' style={{ height: 400 }} />
          </div>
        </div>
      </div>
    )
  }


  renderDataTable = () => {
    return(
      <div className='row'>
        <div className='perf-details col table-responsive' style={{ marginTop: '0px' }}>
          <table className='table'>
            <thead>
              <tr className='first' style={{ fontStyle: 'italic' }}>
                <th>&nbsp;</th>
                <th colSpan='4'>{i18n.t('Attribution Component')}</th>
                <th colSpan='3'>{i18n.t('Average Category Weight')}</th>
                <th colSpan='2'>{i18n.t('Category Performance')}</th>
              </tr>
              <tr className='second'>
                <th rowname='Category' className={'textLeft ' + this.setTblHeadClass('Category')} onClick={() => this.setSortData('Category')}>
                  {i18n.t('Category')}
                </th>
                <th rowname='Allocation' className={this.setTblHeadClass('Allocation')} onClick={() => this.setSortData('Allocation')} style={{ borderLeft: '1px solid white' }}>
                  {i18n.t('Allocation')}
                </th>
                <th rowname='Selection' className={this.setTblHeadClass('Selection')} onClick={() => this.setSortData('Selection')}>
                  Stock
                  <br />
                  {i18n.t('Selection')}
                </th>
                <th rowname='Interaction' className={this.setTblHeadClass('Interaction')} onClick={() => this.setSortData('Interaction')}>
                  {i18n.t('Interaction')}
                </th>
                <th rowname='Total' className={this.setTblHeadClass('Total')} onClick={() => this.setSortData('Total')}>
                  Total
                  <br />
                  {i18n.t('Attribution')}
                </th>
                <th rowname='IndexWgt' className={this.setTblHeadClass('IndexWgt')} onClick={() => this.setSortData('IndexWgt')} style={{ borderLeft: '1px solid white' }}>
                  {i18n.t('Index')}
                  <br />
                  {i18n.t('Weight')}
                </th>
                <th rowname='BenchmarkWgt' className={this.setTblHeadClass('BenchmarkWgt')} onClick={() => this.setSortData('BenchmarkWgt')}>
                  {i18n.t('Benchmark')}
                  <br />
                  {i18n.t('Weight')}
                </th>
                <th rowname='ActiveWgt' className={this.setTblHeadClass('ActiveWgt')} onClick={() => this.setSortData('ActiveWgt')}>
                  +/- {i18n.t('Wgt')}
                </th>
                <th rowname='IndexGroupRet' className={this.setTblHeadClass('IndexGroupRet')} onClick={() => this.setSortData('IndexGroupRet')} style={{ borderLeft: '1px solid white' }}>
                  WT {i18n.t('Index')}
                  <br />
                  {i18n.t('Return')}
                </th>
                <th rowname='BenchmarkGroupRet' style={{ textAlign: 'center' }} className={this.setTblHeadClass('BenchmarkGroupRet')} onClick={() => this.setSortData('BenchmarkGroupRet')}>
                  {i18n.t('Benchmark')}
                  <br />
                  {i18n.t('Return')}
                </th>
              </tr>
            </thead>
            <tbody>{this.renderTable()}</tbody>
          </table>
        </div>
      </div>
    )
  }
  
  renderAllFooters = () => {
    let dateFormat = { month: 'numeric', day: 'numeric', year: 'numeric' }
    const { forBlog } = this.props
    if (forBlog) {
      return null
    }        
    return(
      <div>
        <div className='perffooter'>
          {i18n.t('comp-source')}: {new Date(this.props.pair.inception_date).toLocaleString('en-US', dateFormat)}&nbsp;&nbsp;&nbsp;
          <a href={this.props.pair.index_url} target='_new'>
            {i18n.t('comp-view')}
          </a>
        </div>
        <div className='perffooter'>{i18n.t('comp-inception')}</div>
        {this.renderGlossary()}
        <div className='perffooter'>{i18n.t('Composite Risk Score')}</div>
        <div className='perffooter'>{i18n.t('comp-average')}</div>
        <div className='perffooter-b'>{i18n.t('comp-past')}</div>
        <div className='perffooter-b'>{i18n.t('comp-std')}</div>
        <div className='perffooter-b'>{i18n.t('comp-prospectus')}</div>
      </div>
    )
  }

  renderCopyDownload = () => {
    const { currentURL, pair, forBlog } = this.props

    const blacklist = [
      'RU1000',
      'RU1000G',
      'RU1000V',
      'RU2000',
      'RU2000V',
      'RU3000',
      'RU3000V',
      'RUMIDCAP'
    ]

    const showExcel = pair && !blacklist.includes(pair.benchmark)

    if (forBlog) return null

    return (
      <div className='row'>
        <div className='col-md-12' style={{ padding: '0px' }}>
          {showExcel && (
            <div className='right'>
              <a className='downloadExcelLink' onClick={event => this.getExcelDownload(event)}>
                {' '}
                DOWNLOAD EXCEL
              </a>
            </div>
          )}
          <div className='right' style={{ marginLeft: '10px' }}>
            <CopyToClipboard text={currentURL}>
              <a className='downloadExcelLink' onClick={event => this.getSaveToGA(event, 'link')}>
                {' '}
                COPY LINK
              </a>
            </CopyToClipboard>
          </div>
        </div>
      </div>
    )
  }

  renderData = () => {
    const { pair } = this.props
    if (!pair || !pair.index) return null

    return (
      <div>
        {this.renderCopyDownload()}
        {this.renderDataTable()}
        {this.renderGraphs()}
        {this.renderAllFooters()}
      </div>
    )
  }

  renderStickyHeader = () => {
    return(
      <Sticky innerZ={5} enabled={false} top={0}>
        <div style={{ backgroundColor: 'white', paddingBottom: '10px' }}>
          <div className='row'>
            <div className={`perf-btn-group ${this.props.index ? 'col-md-6' : 'col-md-4'}`}>
              <select onChange={event => this.setIndex(event.target.value)} value={this.props.index}>
                {Object.keys(this.props.pair).length === 0 && <option value=''>{i18n.t('Select a WisdomTree Index')}</option>}
                {this.renderIndexes()}
              </select>
            </div>
            {this.props.index && <div className='col-md-1 perf-btn-group versus'>VS.</div>}
            {this.props.index && (
              <div className='col-md-5 perf-btn-group'>
                <select style={{ fontSize: '13px' }} onChange={event => this.setPair(event.target.value)} value={this.props.pair.uu_attribution_id}>
                  {Object.keys(this.props.pair).length === 0 && <option value=''>{i18n.t('Select a Benchmark')}</option>}
                  {this.renderPairs()}
                </select>
              </div>
            )}
          </div>

          {this.props.pair.index && (
            <div className='row'>
              <div className='col-md-3 perf-btn-group'>
                <select onChange={event => this.setCategory(event.target.value)} value={this.props.category}>
                  {this.renderCategories()}
                </select>
              </div>
              <div className='col-md-1 perf-btn-group'>
                <div className='asofdate'>{i18n.t('As of')}:</div>
              </div>
              <div className='col-md-2 perf-btn-group'>
                <select onChange={event => this.setDate(event.target.value)} value={this.getAsOfDate()}>
                  {this.renderDates()}
                </select>
              </div>
              <div className='col-md-6 perf-btn-group'>
                <div className='right'>{this.renderPeriods()}</div>
              </div>
            </div>
          )}
        </div>
      </Sticky>
    )
  }

  render() {
    return (
      <div className='perf-attr'>
        <div className='perf-btn-toolbar' role='toolbar'>
          {this.renderStickyHeader()}
          {this.renderData()}
        </div>
      </div>
    )
  }

  getHBarOption() {
    return {
      title: {
        text: '',
        left: 12,
        textStyle: {
          fontStyle: 'normal',
          fontWeight: 900,
          fontSize: 15,
          color: '#8c959b'
        }
      },
      legend: {
        data: [],
        itemGap: 20,
        right: 18,
        top: 30
      },
      tooltip: {
        trigger: 'axis',
        formatter: function (params, ticket) {
          var res = params[0].name
          for (var i = 0, l = params.length; i < l; i++) {
            res += '<br/>' + params[i].marker + ' ' + i18n.t(params[i].seriesName) + ' : ' + params[i].value + '%'
          }
          return res
        },
        backgroundColor: '#FFF',
        borderWidth: 1,
        borderColor: '#05A9B1',
        borderRadius: 0,
        textStyle: {
          color: '#5B6770',
          align: 'left'
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: [
        {
          type: 'value',
          axisLabel: {
            formatter: '{value} %'
          }
        }
      ],
      yAxis: [
        {
          type: 'category',
          axisLabel: {
            fontSize: 12,
            fontWeight: 100,
            color: '#596770'
          },
          axisPointer: {
            type: 'shadow'
          },
          data: []
        }
      ],
      series: []
    }
  }

  filterOutTotal(data) {
    let categoryData = data.filter(function (value) {
      return value.Category !== i18n.t('Total')
    })
    return categoryData
  }

  getAverageWeightsOption() {
    let indexLbl = i18n.t('Index') + ' (' + this.props.pair.index + ')'
    let benchLbl = i18n.t('Benchmark') + ' (' + this.props.pair.benchmark + ')'
    let data = this.props.periodData
    let option = this.getHBarOption()
    option.title.text = i18n.t('Average Weights')
    option.legend.data = [indexLbl, benchLbl]
    let filteredData = this.filterOutTotal(data)
    option.yAxis[0].data = filteredData
      .map(row => i18n.t(row.Category))
      .slice()
      .reverse()
    option.series = [
      {
        type: 'bar',
        name: indexLbl,
        itemStyle: { color: 'darkblue' },
        data: filteredData
          .map(item => this.convPerc(item.IndexWgt))
          .slice()
          .reverse()
      },
      {
        type: 'bar',
        name: benchLbl,
        itemStyle: { color: '#0fcbd4' },
        data: filteredData
          .map(item => this.convPerc(item.BenchmarkWgt))
          .slice()
          .reverse()
      }
    ]
    return option
  }

  getOverUnderOption() {
    let data = this.props.periodData
    let option = this.getHBarOption()
    option.title.text = i18n.t('Over/Under Weight')
    option.legend.data = []
    let filteredData = this.filterOutTotal(data)
    option.yAxis[0].data = filteredData
      .map(row => i18n.t(row.Category))
      .slice()
      .reverse()
    option.series = [
      {
        type: 'bar',
        name: 'Index',
        itemStyle: { color: 'darkgreen' },
        data: filteredData
          .map(item => this.convPerc(item.ActiveWgt))
          .slice()
          .reverse()
      }
    ]
    return option
  }

  getVBarOption() {
    return {
      title: {
        text: '',
        left: 12,
        textStyle: {
          fontStyle: 'normal',
          fontWeight: 900,
          fontSize: 15,
          color: '#8c959b'
        }
      },
      legend: {
        itemGap: 20,
        top: 30,
        data: []
      },
      tooltip: {
        trigger: 'axis',
        formatter: function (params, ticket) {
          var res = params[0].name
          for (var i = 0, l = params.length; i < l; i++) {
            res += '<br/>' + params[i].marker + ' ' + i18n.t(params[i].seriesName) + ' : ' + params[i].value + '%'
          }
          return res
        },
        backgroundColor: '#FFF',
        borderWidth: 1,
        borderColor: '#05A9B1',
        borderRadius: 0,
        textStyle: {
          color: '#5B6770',
          align: 'left'
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: [
        {
          type: 'category',
          axisLabel: {
            fontSize: 12,
            fontWeight: 100,
            color: '#596770',
            rotate: 45,
            interval: 0,
            align: 'right'
          },
          axisPointer: {
            type: 'shadow'
          },
          data: []
        }
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: {
            formatter: '{value} %'
          }
        }
      ],
      series: []
    }
  }

  getAttributionOption() {
    let data = this.props.periodData
    let option = this.getVBarOption()
    option.title.text = i18n.t('Performance Attribution')
    option.legend.data = [i18n.t('Allocation'), i18n.t('Selection'), i18n.t('Interaction'), i18n.t('Total Attribution')]
    if (isMobileOnly) {
      option.grid.top = 100
    }
    option.xAxis[0].data = data.map(row => i18n.t(row.Category))
    option.series = [
      {
        type: 'bar',
        stack: 'true',
        name: 'Allocation',
        itemStyle: { color: '#0fcbd4' },
        data: data.map(item => this.convPerc(item.Allocation))
      },
      {
        type: 'bar',
        stack: 'true',
        name: 'Selection',
        itemStyle: { color: 'darkblue' },
        data: data.map(item => this.convPerc(item.Selection))
      },
      {
        type: 'bar',
        stack: 'true',
        name: 'Interaction',
        itemStyle: { color: '#8c959b' },
        data: data.map(item => this.convPerc(item.Interaction))
      },
      {
        type: 'scatter',
        symbol: 'diamond',
        symbolSize: 20,
        name: 'Total Attribution',
        itemStyle: { color: 'orange', opacity: 1 },
        data: data.map(item => this.convPerc(item.Total))
      }
    ]
    return option
  }
}

function mapStateToProps(state) {
  return {
    pairs: state.performance.pairs,
    index: state.performance.index,
    pair: state.performance.pair,
    dates: state.performance.dates,
    categories: state.performance.categories,
    category: state.performance.category,
    categoryData: state.performance.categoryData,
    period: state.performance.period,
    periodData: state.performance.periodData,
    sortColumn: state.performance.sortColumn,
    sortDirection: state.performance.sortDirection,
    currentURL: state.performance.currentURL
  }
}

export default withRouter(
  connect(mapStateToProps, {
    loadPairs,
    loadPerformance,
    setIndex,
    setPair,
    setDate,
    setPeriod,
    setCategory,
    setSort,
    setUrlDate,
    setUrlPeriod,
    setUrlCategory,
    saveToGA,
    loadAttributionExcel
  })(App)
)



// WEBPACK FOOTER //
// ./src/components/App/index.js